import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TourCostService', TourCostService);

  TourCostService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function TourCostService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'tours';

    var service = {
      searchTourCosts: searchTourCosts,
      saveTourCosts: saveTourCosts,
      searchTourPickupCosts: searchTourPickupCosts,
      saveTourPickupCosts: saveTourPickupCosts,
    };

    return service;

    ////////////////

    function searchTourCosts(tour, filterCriteria) {
      var url = apiUrl + '/' + tour.id + '/tour_costs';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = tour.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTourCosts(tour, params, editMode) {
      var url = apiUrl + '/' + tour.id + '/tour_costs';

      params.company_id = tour.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'COSTS_ADDED' : 'UPDATED_COSTS';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }

    function searchTourPickupCosts(tour, filterCriteria) {
      var url = apiUrl + '/' + tour.id + '/tour_pickup_costs';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = tour.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTourPickupCosts(tour, params, editMode) {
      var url = apiUrl + '/' + tour.id + '/tour_pickup_costs';

      params.company_id = tour.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PICKUP_COSTS_ADDED' : 'PICKUP_COSTS_UPDATED';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
